/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_DescriptionInputs */

const en_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI is a curated directory of the best AI tools — every listing scored by independent AI agents on six dimensions, with weekly price checks and agent-readiness checks. Compare features, pricing, and alternatives to find the right tools for your workflow.`)
};

const zh_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 为每个任务找到最好的 AI 工具——写作、视频、代码、设计。每个条目独立六维评分、定价每周核实、替代逐项对比。先看证据再决定。`)
};

/**
* | output |
* | --- |
* | "Seek AI is a curated directory of the best AI tools — every listing scored by independent AI agents on six dimensions, with weekly price checks and agent-rea..." |
*
* @param {Site_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const site_description = /** @type {((inputs?: Site_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_site_description(inputs)
	return zh_site_description(inputs)
});
export { site_description as "site.description" }